<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <div id="mapnew"></div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
//import func from '../../../vue-temp/vue-editor-bridge';
var marker;
export default {
  props: ["id"],
  data() {
    return {
     colonyData:[]
    };
  },
  mounted:function()
  {
    if(this.id)
this.map1()
  },
  methods:{
   map1(){
       this.appLoading = true;
      axios({
        method: "GET",
        url: "/colony/admingetlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          cluster: this.id,
        },
      })
        .then((response) => {
          this.appLoading = false;

          if (response.data.status === true) {
            this.colonyData = response.data.data;
             var mapCanvas = document.getElementById("mapnew");

              var mapOptions = {
                center: new google.maps.LatLng(
                  this.colonyData[0].location[1],
                  this.colonyData[0].location[0]
                ),
                zoom: 18,

                mapTypeId: google.maps.MapTypeId.TERRAIN,
              };
              var vm = this;

               vm.map = new google.maps.Map(mapCanvas, mapOptions);

              // var data = {};

              for (var i = 0; i < this.colonyData.length; i++) {
                var lat = this.colonyData[i].location[1];
                var lon = this.colonyData[i].location[0];
                var latlngset = new google.maps.LatLng(lat, lon);
   var icon = {
                  url:
                    "http://arhiveadmin.leopardtechlabs.com/img/orangemarker.png", // url
                  scaledSize: new google.maps.Size(20, 32), // scaled size
                  origin: new google.maps.Point(0, 0), // origin
                  anchor: new google.maps.Point(0, 0), // anchor
                };
                marker = new google.maps.Marker({
                  map: vm.map,
                  position: latlngset,
                  icon: icon,
                  // icon: iconBase
                });
                console.log(i, "i");

                console.log("hilo");

                var content =
                  '<p>Colony ID: <span style="color:red">' +
                  this.colonyData[i].colonyidentifier +
                  "</span></p>" +
                  ' Colony Status: <span style="color:green">' +
                  this.colonyData[i].colonystatus +
                  "</span></p>" +
                  '<a href="/colonyDetails/' +
                  this.colonyData[i]._id +
                  '"><button class="btn btn-success" >View Details</button></a>';

                var infowindow = new google.maps.InfoWindow();

                google.maps.event.addListener(
                  marker,
                  "click",
                  (function (marker, content, infowindow) {
                    return function () {
                      infowindow.setContent(content);
                      infowindow.open(vm.map, marker);
                    };
                  })(marker, content, infowindow)
                );
              }
   this.appLoading = false;
          } else if (response.data.status === false) {
            this.appLoading = false;
          }
        })
        .catch((e) => {
          this.appLoading = false;
          //this.errors.push(e);
          this.msg = "failed";
        });
    },
  }
}
</script>
<style scoped>
#mapnew {
  height: 600px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>